/**
 * Verify user screen
 * Verify user email after signup
 * After successful verification the user is logged in automatically and redirected to the create profile screen
 */
import React from "react"
import { ThemeProvider } from "styled-components"
import theme from "styles/theme-main"
import {
  ConfirmationWrapper,
  ConfirmationContent,
  IconCont,
  ModalTitle,
  InformationContainer,
  InfomationRow,
  InformationData,
  InformationLabel,
  ButtonWrapper,
} from "./styles"
import { baseURL } from "utils/config"
import { format } from "date-fns"
import Button from "components/Button"
import Text from "components/Text"
import Icon from "components/Icon"
import { generateGoogleLink } from "services/public"
import { formatEventTime, getTimezone } from "utils/utils"

export class EventInformation extends React.Component {
  register = () => {
    this.setState({
      isRegisterModal: true,
    })
  }

  render() {
    const { event } = this.props

    const generateOutlookLink = () => {
      window.open(`${baseURL}/api/public/event/${event.id}/ical`)
    }

    const generateGoogleLinkx = () => {
      this.setState({ loading: true })
      generateGoogleLink("event", this.props.event.id).then(res => {
        this.setState({ loading: false })
        window.open(res.data.url)
      })
    }

    const timezone = getTimezone()

    return (
      <ThemeProvider theme={theme}>
        <ConfirmationWrapper>
          <ConfirmationContent>
            <ModalTitle variant={"sectionTitle"} as={"h1"} weight={"light"}>
              <IconCont>
                <Icon variant={"green_circle_tick"} />
              </IconCont>
              You are registered for this event
            </ModalTitle>
            <Text>You are now attending:</Text>
            <InformationContainer>
              <InfomationRow>
                <InformationLabel>Event:</InformationLabel>
                <InformationData>{event.name}</InformationData>
              </InfomationRow>
              <InfomationRow>
                <InformationLabel>Date:</InformationLabel>
                <InformationData>
                  {format(event.eventStartDate, "dd/MM/yyyy")}
                </InformationData>
              </InfomationRow>
              <InfomationRow>
                <InformationLabel>Time:</InformationLabel>
                <InformationData>
                  {formatEventTime(event.eventStartDate, event.eventEndDate)}
                  {timezone}
                </InformationData>
              </InfomationRow>
              <InfomationRow>
                <InformationLabel>
                  {event.type === "ONLINE" ? "Event link" : "Location"}:
                </InformationLabel>
                <InformationData>
                  {event.type === "OFFLINE" ? (
                    <React.Fragment>
                      {[
                        event.venue,
                        event.line1,
                        event.line2,
                        event.town,
                        event.postCode,
                      ]
                        .filter(x => x)
                        .join(", ")}
                    </React.Fragment>
                  ) : (
                    event.link
                  )}
                </InformationData>
              </InfomationRow>
            </InformationContainer>
            <InfomationRow>
              <Text>You will receive an email with the event details.</Text>
            </InfomationRow>
            <InfomationRow>
              <Text weight={"bold"}>Add this event to your calendar:</Text>
            </InfomationRow>
            <ButtonWrapper>
              <Button
                label={"Add to iCal/Outlook"}
                onClick={generateOutlookLink}
                width={"332px"}
              />
              <Button
                label={"Add to Google Calendar"}
                onClick={generateGoogleLinkx}
                width={"332px"}
              />
            </ButtonWrapper>
          </ConfirmationContent>
        </ConfirmationWrapper>
      </ThemeProvider>
    )
  }
}

export default EventInformation
